module.exports = "<div class=\"gw-quotewizard\">\n    <div class=\"gw-wizard\">\n        <div class=\"gw-wizard-sidebar\">\n            <div class=\"gw-wizard-sidebar-steps-wrapper\">\n                <div gw-wizard-sidebar-ribbon title=\"{{'quoteandbind.views.qnb.Quote Request' | translate }}\"></div>\n            </div>\n            <div gw-wizard-sidebar-additional/>\n        </div>\n        <div gw-wizard-content>\n            <div ui-view></div>\n        </div>\n    </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/common/views/base-qnb-wizard.html
 ** module id = 431
 ** module chunks = 0
 **/